"use client";

import dynamic from "next/dynamic";

const BlockMusicIntroduction = dynamic(() =>
  import("./BlockMusicIntroduction").then(mod => mod.BlockMusicIntroduction),
);

export const BlockMusicIntroductionWrapper = () => {
  return <BlockMusicIntroduction />;
};
